"use client";
import { useEffect } from "react";
import * as All from '@/element/common/elmntbase';


export default function Loader() {
//   useEffect(() => {
//     const timeline = async () => {
//       await new Promise((resolve) => setTimeout(resolve, 1500));

//       // Text Animation
//       document.querySelectorAll(".loader-wrap-heading .load-text, .loader-wrap-heading .cont")
//         .forEach(el => el.classList.add('hidden')); // Hides elements

//       // SVG Animation
//       const svgPath = document.getElementById("svg");
//       if (svgPath) {
//         svgPath.setAttribute("d", "M0 502S175 272 500 272s500 230 500 230V0H0Z");
//         // await new Promise((resolve) => setTimeout(resolve, 500));
//         svgPath.setAttribute("d", "M0 2S175 1 500 1s500 1 500 1V0H0Z");
//       }

//       // Loader Wrap Animation
//       const loaderWrap = document.querySelector(".loader-wrap");
//       if (loaderWrap) {
//         loaderWrap.style.transform = "translateY(-1500px)";
//         loaderWrap.style.zIndex = "-1";
//         loaderWrap.style.display = "none";
//       }

//       // Header Animation
//       const header = document.querySelector("header");
//       if (header) {
//         header.style.transform = "translateY(0)";
//         header.style.opacity = "1";        
//       }

//       const headerContainer = document.querySelector(".tc-header-st5 .container");
//       if (headerContainer) {
//         headerContainer.style.transform = "translateY(0)";
//         headerContainer.style.opacity = "1";
//       }
//     };

//     timeline();
//   }, []);

//   const pathVariants = {
//     initial: { d: "M0,1005S175,995,500,995s500,5,500,5V0H0Z" },
//     curve: { d: "M0 502S175 272 500 272s500 230 500 230V0H0Z", transition: { duration: 0.5, ease: "easeInOut" } },
//     flat: { d: "M0 2S175 1 500 1s500 1 500 1V0H0Z", transition: { duration: 1, ease: "easeOut" } },
//   };
  
  return(
    <All.MotionDiv className="loader-wrap" 
    animate={{
        translate: "none",
        rotate: "none",
        scale: "none",
        transform: "translate(0px, -1500px)",
        display: "none",
        zIndex: -1
    }}
    transition={{ duration: 0.5, ease: "easeOut" }}
    >
            <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
                <All.MotionSVGPath 
                    id="svg"                    
                    initial={{ d: "M0,1005S175,995,500,995s500,5,500,5V0H0Z" }}
                    // animate={['curve','flat']}
                    animate={{
                        d: [
                          "M0 502S175 272 500 272s500 230 500 230V0H0Z", // Curve
                          "M0 2S175 1 500 1s500 1 500 1V0H0Z"             // Flat
                        ]
                      }}
                      transition={{
                        // delay: 2,
                        duration: 1, // Total duration for both animations
                        times: [0.5, 1], // First animation at 50%, second at 100%
                        ease: "easeInOut"
                      }}
                      fill="#000"
                    // variants={pathVariants}
                    >                    
                </All.MotionSVGPath>
            </svg>
            <All.MotionDiv
                className="loader-wrap-heading"
                initial={{ opacity: 1, y: 0 }}
                animate={{ opacity: 0, y: -100 }}
                transition={{ delay: 1.5, duration: 0.5 }}
            >
                <div className="load-text">
                        <span>L</span>
                        <span>o</span>
                        <span>a</span>
                        <span>d</span>
                        <span>i</span>
                        <span>n</span>
                        <span>g</span>
                </div>
            </All.MotionDiv>
        </All.MotionDiv>
  )
}